import BaseAPIService from 'src/services/base/base-api-service';
import BaseModel from 'src/model/base.model';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import env from 'src/shared/env';

/**
 * This endpoint can receive the next params
 * username: string,
 * password: string
 */

class SubcategoryService extends BaseAPIService<BaseModel> {
  private basicURL: string = env.REACT_APP_BASE_API_URL;

  private buildSubcategoryProductsEndpoint(categoryId: string) {
    return `${this.basicURL}navapp/v1/subcategory/category/${categoryId}`;
  }

  private buildProductsEndpoint(categoryId: string) {
    return `${this.basicURL}navapp/v1/product/subcategory/${categoryId}`;
  }

  private buildSubcategoriesFilterListEndpoint(subcategoryId: string) {
    return `${this.basicURL}navapp/v1/subcategory/${subcategoryId}/filter`;
  }

  private buildSubcategoriesFilteredEndpoint(
    subcategoryId: string,
    filters: SubcategoryFilter[]
  ) {
    let filtersUrl = '';
    let cont = 0;
    console.log('filters', filters);
    const regExp = /\(([^)]+)\)/;

    filters.map((filter: SubcategoryFilter) => {
      filtersUrl =
        cont === 0
          ? `=${
              regExp.exec(filter.name)
                ? escape(filter.name)
                : encodeURIComponent(filter.name)
            }`
          : `${filtersUrl}&filter=${
              regExp.exec(filter.name)
                ? escape(filter.name)
                : encodeURIComponent(filter.name)
            }`;
      cont++;
    });

    return encodeURI(
      `${this.basicURL}navapp/v1/product/subcategory/${subcategoryId}?filter${filtersUrl}`
    );
  }

  public getSubcategories(categoryId: string) {
    const endpoint: string = this.buildSubcategoryProductsEndpoint(categoryId);

    return new Promise((resolve, reject) => {
      this.getAll(endpoint)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getProductsBySubcategory(
    subcategoryId: string,
    customerId: string,
    pageNumber: number = 0,
    productsPerPage: number
  ) {
    const endpoint: string = this.buildProductsEndpoint(subcategoryId);
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint, {
        page: pageNumber,
        size: productsPerPage
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getSubcategoriesFilters(subcategoryId: string) {
    const endpoint: string = this.buildSubcategoriesFilterListEndpoint(
      subcategoryId
    );
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint)
        .then((response: any) => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getSubcategoriesFiltered(
    subcategoryId: string,
    filters: SubcategoryFilter[],
    pageNumber: number = 0,
    productsPerPage: number
  ) {
    const endpoint: string = this.buildSubcategoriesFilteredEndpoint(
      subcategoryId,
      filters
    );
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint, { page: pageNumber, size: productsPerPage })
        .then((response: any) => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const subcategoryServiceInstance = new SubcategoryService(BaseModel);
Object.freeze(subcategoryServiceInstance);

export default subcategoryServiceInstance;
